module.exports = __webpack_public_path__ + "static/media/NunitoSans-ExtraBoldItalic.d0f3e4b8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NunitoSans-ExtraBoldItalic.woff
// module id = 3162
// module chunks = 51